import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: null // 存储 token
  },
  mutations: {
    setToken(state, token) {
      console.log(token, '----->111111')
      state.token = token // 设置 token
    },
    clearToken(state) {
      state.token = null // 清除 token
    }
  },
  actions: {
    login({ commit }, token) {
      commit('setToken', token) // 登录时保存 token
    },
    logout({ commit }) {
      commit('clearToken') // 注销时清除 token
    }
  },
  getters: {
    isAuthenticated(state) {
      return !!state.token // 判断是否已认证
    }
  }
})
